import './publicpath';

// The Vue build version to load with the `import` command (runtime-only or standalone) has been set in
// webpack.base.conf with an alias.
import { createApp } from 'vue';

// Import the router config, this will load the file ./router/index.js
import router from './router';

// Import the application's store
import { createPinia } from 'pinia';
const pinia = createPinia();
import { useGlobalStore } from './stores';

// Import the application's language controller
import i18n from './i18n';

import PortalApp from './components/App';

// Import Element UI components we'd like to use globally, our custom theme and locale information
import ElementPlus from 'element-plus';
import { ElNotification } from 'element-plus';

// Import css
import './styles.scss';
import './css/base.css';
import './css/container.css';
import './css/frame.css';
import './css/inputs.css';

// Start the application
const app = createApp(PortalApp);

app.use(ElementPlus);
app.use(router);
app.use(i18n);
app.use(pinia);

// Register any Element UI components we want to use globally
app.config.globalProperties.$store = useGlobalStore();
app.config.globalProperties.$notify = ElNotification;

app.config.errorHandler = (err, vue, info) => {
    alert(i18n.global.t('APP_ERROR'));
    try {
        const params =
            'err=' + err + '&vue=' + (vue?.$vnode?.tag ?? '') + '&info=' + info + '&url=' + window.location.href;
        fetch('error', {
            headers: { 'Content-type': 'application/x-www-form-urlencoded' },
            method: 'POST',
            body: params,
        });
    } catch (e) {
        console.log(e);
    }
};

app.mount('#app');
